exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Indie+Flower);", ""]);

// module
exports.push([module.id, ".invisible{opacity:0}.appear{opacity:1!important}body{margin:0;overflow-x:hidden;background-color:#f5f5f5}div#app.nightMode{background-color:#1e2021;height:100vh;overflow:hidden}@keyframes fadeIn{0%,30%{opacity:0}to{opacity:1;animation-timing-function:ease-in}}@keyframes disappearQuickly{0%{opacity:1}15%,to{opacity:0}}@keyframes appearSlowly{0%,50%{opacity:0}to{opacity:1}}", ""]);

// exports
